export default "__VITE_ASSET__DuGx1bUG__"